import { Injectable } from '@angular/core';
import type { PositionOptions } from '@capacitor/geolocation';
import { Geolocation } from '@capacitor/geolocation';

import type { TCoordinate } from '@shared/models';
import { Constants } from '@shared/models';
import { SessionService } from './session.service';
// https://enappd.com/blog/use-geolocation-geocoding-and-reverse-geocoding-in-ionic-capacitor/131/

// /////////////////
// import { Geolocation } from '@capacitor/geolocation';
// const printCurrentPosition = async () => {
//   const coordinates = await Geolocation.getCurrentPosition();
//   console.log('Current position:', coordinates);
// };
//

@Injectable({
    'providedIn': 'root'
})
export class GeolocationService {
    private options: PositionOptions = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
    };

    // private geolocation: Geolocation
    constructor(private sessionService: SessionService) {
    }

    // For Capacitor
    // public async requestPermissions(): Promise<void> { //} Promise<PermissionStatus> {
    //     const permStatus = await Geolocation.requestPermissions();
    //     console.log('Permission status: ', permStatus);
    //     // return permStatus;
    // }
    // const printCurrentPosition = async () => {
    //   const coordinates = await Geolocation.getCurrentPosition();

    //   console.log('Current position:', coordinates);
    // };

    public async getCurrentLocation(): Promise<TCoordinate> {
        try {
            let coords: TCoordinate = Constants.NULL_COORDINATE;

            const coordinates = await Geolocation.getCurrentPosition(this.options);
            if (coordinates && coordinates.coords) {
                coords = {
                    'latitude': coordinates.coords.latitude,
                    'longitude': coordinates.coords.longitude
                };
            } else {
                coords = this.getFallbackCoordinate();
            }
            return coords;
        } catch (err) {
            throw new Error('Error getting current location: ' + err);
            // return Constants.NULL_COORDINATE;
        }
    }

    // public getPositionObservable_Original() {
    //     const options = {
    //         enableHighAccuracy: true,
    //         timeout: 5000,
    //         maximumAge: 0
    //     };
    //     //   id = navigator.geolocation.watchPosition(success, error, options);
    //     const watchObservable = this.geolocation.watchPosition(options);
    //     // const watchObservable = await Geolocation.watchPosition(this.options);
    //     // const watchObservable = this.geolocation.watchPosition(successCallback, errorCallback, options);
    //     return watchObservable;
    // }

    // TODO: This is not working.  I need to figure out how to get the observable to work.
    // Look at shuttleMovement.service approx line 74
    public async getPositionObservable(callback: any) {
        //   id = navigator.geolocation.watchPosition(success, error, options);
        // const watchObservable = this.geolocation.watchPosition(options);
        // const watchObservable = await Geolocation.watchPosition(this.options);
        // const watchObservable = this.geolocation.watchPosition(successCallback, errorCallback, options);
        // return watchObservable;

        const watchObservable = await Geolocation.watchPosition(this.options, (data) => {
            callback(data);
        });

        return watchObservable;
    }

    // private example() {
    //     const watchObservable = this.getPositionObservable();
    //     const subscription = watchObservable.subscribe((data) => {
    //         // data can be a set of coordinate, or an error (if an error occurred).
    //         // data.coords.latitude
    //         // data.coords.longitude
    //     });
    //     subscription.unsubscribe();
    // }

    // public async getCurrentOrDealershipLocation(): Promise<TCoordinate> {
    //     try {
    //         let currentCoordinate = await this.getCurrentLocation();
    //         if (!currentCoordinate?.latitude || !currentCoordinate?.longitude) {
    //             currentCoordinate = this.getFallbackCoordinate();
    //         }
    //         return currentCoordinate;
    //     } catch (error) {
    //         console.error('Error fetching current location:', error);
    //     }
    // }

    private getFallbackCoordinate(): TCoordinate {
        // return this.sessionService.getDealership()?.address?.coordinate || { latitude: 0, longitude: 0 };
        const dealership = this.sessionService.getDealership();
        const dealershipAddress = dealership.address;
        const dealershipCoordinate = dealershipAddress.coordinate;
        return dealershipCoordinate;
    }
}
